<template>
  <div class="user-management-bind-google main-second-bg">
    <p class="user-management-child-header main-cl a-3-bd">
      {{ $t("personal.bindGoogle.title") }}
    </p>
    <div class="user-management-center main-second-bg">
      <div class="center-one a-3-bd">
        <p class="titleArea center-one-title">
          <span class="index">1</span>
          <span class="text main-cl">{{ $t("personal.bindGoogle.downloadGoogle")[0] }}</span>
        </p>
        <p class="center-text">{{ $t("personal.bindGoogle.downloadGoogle")[1] }}</p>
        <div style="margin-top: 24px;">
          <c-button
            type="solid"
            :big="true"
            className="center-one-button"
            paddingW="0px"
            :disabled="false"
            marginTop="0px"
            height="40px"
            width="198px"
            @click="btnLink('appstore')"
          >
            <div class="iconButton">
              <svg-icon class="icon icon-18" icon-class="appstore"></svg-icon>
              <span class="text">{{ $t("personal.bindGoogle.appStore") }}</span>
            </div>
          </c-button>
          <c-button
            type="solid"
            :big="true"
            className="center-one-button"
            paddingW="0px"
            :disabled="false"
            marginTop="0px"
            height="40px"
            width="198px"
            @click="btnLink('googleplay')"
          >
            <div class="iconButton">
              <svg-icon class="icon icon-18" icon-class="GoogleStore"></svg-icon>
              <span class="text">{{ $t("personal.bindGoogle.googlePlay") }}</span>
            </div>
          </c-button>
          <!-- 下载谷歌验证器的Android跳转链接不对，是过时的腾讯应用宝安装链接。国内相关链接经常变化 去掉Android按钮 -->
          <!-- <c-button
            type="solid"
            :big="true"
            className=""
            paddingW="0px"
            :disabled="false"
            marginTop="14px"
            height="40px"
            width="198px"
            @click="btnLink('android')"
          >
            <div class="iconButton">
              <svg-icon class="icon icon-18" icon-class="Android"></svg-icon>
              <span class="text">{{ $t("personal.bindGoogle.android") }}</span>
            </div>
          </c-button> -->
        </div>
      </div>
      <div class="center-two a-3-bd">
        <p class="titleArea center-two-title">
          <span class="index">2</span>
          <span class="text main-cl">{{ $t("personal.bindGoogle.useGoogle")[0] }}</span>
        </p>
        <p class="center-text">{{ $t("personal.bindGoogle.useGoogle")[1] }}</p>
        <div class="center-two-ewm">
          <div class="qrcodeArea">
            <img class="image" :src="googleImg" />
          </div>
          <div class="actionArea">
            <c-button type="text" @click="reload" class="reload-btn">
              {{ $t("common.reload") }}
            </c-button>
            <p class="copyText gray-30-bg white-cl">
              {{ googleKey }}
              <span @click="copyClick" @mouseenter="handMouseenter" @mouseleave="handMouseleave">
                <svg-icon v-if="googleKey" class="icon icon-14" icon-class="resetCopyIcon"></svg-icon>
              </span>
            </p>
          </div>
        </div>
      </div>
      <div class="center-three">
        <p class="titleArea center-three-title">
          <span class="index">3</span>
          <span class="text main-cl">{{ $t("personal.bindGoogle.bindGoogle")[0] }}</span>
        </p>
        <p class="center-three-y-title">
          <svg-icon class="icon icon-14" icon-class="warningIcon"></svg-icon>
          <span class="red-cl">{{ $t("personal.bindGoogle.bindGoogle")[1] }}</span>
        </p>
        <div class="center-three-form">
          <c-inputLine
            name="password"
            maxLength="20"
            inputType="password"
            :promptText="promptText4"
            :errorHave="true"
            :errorText="errorText4"
            :errorFlag="checkErrorFlag4"
            marginTop="0px"
            :value="checkValue4"
            @onchanges="inputChanges"
            newStyleFormat
          >
          </c-inputLine>
          <c-inputLine
            name="googleCode"
            maxLength="6"
            inputType="text"
            :promptText="promptText5"
            :errorHave="true"
            :errorText="errorText5"
            :errorFlag="checkErrorFlag5"
            marginTop="0px"
            :value="checkValue5"
            @onchanges="inputChanges"
            newStyleFormat
          >
          </c-inputLine>
          <c-button
            type="solid"
            :big="true"
            className=""
            paddingW="0px"
            :loading="loading"
            :disabled="disabled"
            marginTop="18px"
            height="40px"
            width="100%"
            @click="btnLink"
            >{{ $t("personal.tool.bind") }}</c-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bindEmail',

  watch: {
    userInfo(userinfo) {
      this.googleCode = !!Number(userinfo.googleStatus);
      this.smsCode = !!Number(userinfo.isOpenMobileCheck);
    },
    toopenGoogleAuthenticator(toopenGoogleAuthenticator) {
      this.googleImg = toopenGoogleAuthenticator.googleImg;
      this.googleKey = toopenGoogleAuthenticator.googleKey;
    },
    googleVerify(googleVerify) {
      if (googleVerify !== null) {
        this.loading = false;
        if (googleVerify.text === 'success') {
          this.$bus.$emit('tip', { text: googleVerify.msg, type: 'success' });
          this.$store.dispatch('resetType');
          this.$router.push('/personal/userManagement');
        } else {
          this.$bus.$emit('tip', { text: googleVerify.msg, type: 'error' });
          this.$store.dispatch('resetType');
        }
      }
    },
  },
  computed: {
    userInfo() {
      return this.$store.state.baseData.userInfo;
    },
    toopenGoogleAuthenticator() {
      return this.$store.state.personal.toopenGoogleAuthenticator;
    },
    googleVerify() {
      return this.$store.state.personal.googleVerify;
    },
  },
  data() {
    return {
      svgShow: true,
      loading: false,
      checkValue4: '',
      checkValue5: '',
      promptText4: this.$t('personal.label.password'),
      promptText5: this.$t('personal.label.googleCodeText'),
      errorText4: this.$t('personal.prompt.errorPasswordText'),
      errorText5: this.$t('personal.prompt.errorCode'),
      checkErrorFlag4: false,
      checkErrorFlag5: false,
      disabled: true,
      oldNew: false,
      smsCode: false,
      googleCode: false,
      autoStart: false,
      googleImg: '',
      googleKey: '',
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$store.dispatch('toopenGoogleAuthenticator');
      if (this.userInfo) {
        this.googleCode = !!Number(this.userInfo.googleStatus);
        this.smsCode = !!Number(this.userInfo.isOpenMobileCheck);
      }
    },
    reload() {
      this.init();
    },
    handMouseenter() {
      this.svgShow = false;
    },
    handMouseleave() {
      this.svgShow = true;
    },
    copyClick() {
      this.copy(this.googleKey);
    },
    copy(str) {
      this.$bus.$emit('tip', { text: this.$t('personal.prompt.copySucces'), type: 'success' });
      function save(e) {
        e.clipboardData.setData('text/plain', str); // 下面会说到clipboardData对象
        e.preventDefault(); // 阻止默认行为
      }
      document.addEventListener('copy', save);
      document.execCommand('copy'); // 使文档处于可编辑状态，否则无效
      document.removeEventListener('copy', save);
    },
    // 密码正则
    passFlag(val) {
      return this.$store.state.regExp.passWord.test(val);
    },
    codeFlag(val) {
      return this.$store.state.regExp.verification.test(val);
    },
    getCodeClick(name) {
      if (name === 'phone') {
        this.$bus.$emit('getCode-start', 'phone');
        const info = { operationType: 5 };
        this.$store.dispatch('sendSmsCode', info);
      }
    },
    inputChanges(value, name) {
      if (name === 'password') {
        this.checkValue4 = value;
        if (this.passFlag(value)) {
          this.checkErrorFlag4 = false;
        } else {
          this.checkErrorFlag4 = true;
        }
      } else {
        this.checkValue5 = value;
        if (this.codeFlag(value)) {
          this.checkErrorFlag5 = false;
        } else {
          this.checkErrorFlag5 = true;
        }
      }
      if (this.checkValue5 && this.checkValue4 && !this.checkErrorFlag4 && !this.checkErrorFlag5) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    btnLink(name) {
      if (name === 'appstore') {
        window.open('https://itunes.apple.com/us/app/google-authenticator/id388497605?mt=8');
      } else if (name === 'googleplay') {
        window.open(
          'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2',
        );
      } else if (name === 'android') {
        window.open(
          'https://sj.qq.com/myapp/detail.htm?apkName=com.google.android.apps.authenticator2',
        );
      } else {
        this.loading = true;
        const info = {
          googleKey: this.googleKey,
          googleCode: this.checkValue5,
          loginPwd: this.checkValue4,
        };
        this.$store.dispatch('googleVerify', info);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";

.titleArea {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;

  .index {
    font-size: 14px;
    background-color: $white;
    color: $dark-bg;
    width: 28px;
    height: 28px;
    border-radius: 4px;
    text-align: center;
    line-height: 28px;
  }

  .text {
    font-size: 18px;
    line-height: 28px;
  }
}

.light {
  .titleArea {
    .index {
      background-color: $dark-bg;
      color: $white;
    }
  }
}

.iconButton {
  display: flex;
  justify-content: center;
  gap: 8px;
  align-items: center;

  .icon {
    font-size: 21px;
  }

  .text {
    font-size: 14px;
  }
}

.user-management-bind-google {
  width: 100%;
  border-radius: 6px;
  overflow: hidden;

  .user-management-child-header {
    font-size: 18px;
    padding: 18px 0 18px 20px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    box-sizing: border-box;
  }
  .user-management-center i {
    width: 14px;
    height: 16px;
  }
  .center-title {
    font-size: 12px;
    margin: 0 auto;
    padding: 20px 0 54px 0;
  }
  .center-one {
    padding: 24px;
    border-bottom-style: solid;
    border-bottom-width: 1px;
  }

  .center-two {
    padding: 24px;
    border-bottom-style: solid;
    border-bottom-width: 1px;

    svg {
      float: right;
      cursor: pointer;
      margin-top: 14px;
      margin-right: 10px;
    }

    .center-two-ewm {
      margin-top: 12px;
      width: 460px;
      display: flex;
      gap: 12px;
      align-items: self-end;

      .qrcodeArea {
        width: 90px;
        height: 90px;
        border-radius: 4px;
        overflow: hidden;

        .image {
          width: 100%;
          height: 100%;
        }
      }

      .actionArea {
        display: flex;
        flex: 1;
        flex-direction: column;
        gap: 8px;

        .reload-btn {
          width: 50px;
          padding: 0 !important;
          text-align: left;
        }

        .copyText {
          box-sizing: border-box;
          width: 350px;
          height: 40px;
          padding: 0 20px;
          line-height: 40px;
          border-radius: 4px;
        }
      }
    }
  }

  .center-three {
    padding: 24px;
  }
  .center-three-y-title {
    display: flex;
    gap: 5.5px;
    align-items: center;
    font-size: 14px;
    margin-bottom: 36px;
    line-height: 18px;
  }
  .center-three-y-title i {
    float: left;
    width: 14px;
    height: 12px;
    margin: 0 10px 20px 28px;
  }
  .center-three-form {
    width: 447px;
  }
  .center-text {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
  }

  .center-input {
    width: 447px;
    margin: 0 auto;
    padding-top: 70px;
  }
  .center-one-button {
    margin-right: 20px;
  }
  .user-management-child-header .user-button {
    position: inherit;
  }
}
</style>
